module.exports = __webpack_public_path__ + "static/proyecta-4dedbfab1e1232fe4a6e7a1feca241e3.png";